export default "__VITE_ASSET__de26cc80__"